import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';  // import ThemeProvider here
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import RonsRants from './pages/RonsRants';


import SurveyApp from './pages/beef/SurveyApp';
import Templates from './pages/beef/Templates';
//import ABHS from './pages/beef/data-preparation/abhs2021';
import DataUploads from './pages/beef/DataUploads';
import AppInstall from './pages/beef/AppInstall';

import { lightTheme, darkTheme } from './themes';
import './App.css';

import Abhs2019Content from './pages/beef/data-preparation/abhs2019'; 
import Abhs2020Content from './pages/beef/data-preparation/abhs2020';
import Abhs2021Content from './pages/beef/data-preparation/abhs2021';

import Cvc2024Content from './pages/beef/data-preparation/cvc2024'; 
import Cvc2023Content from './pages/beef/data-preparation/cvc2023'; 
import Cvc2022Content from './pages/beef/data-preparation/cvc2022';
import Cvc2021Content from './pages/beef/data-preparation/cvc2021';
import Cvc2020Content from './pages/beef/data-preparation/cvc2020';
import Cvc2019Content from './pages/beef/data-preparation/cvc2019';

import Fhms2025Content from './pages/beef/data-preparation/fhms2025';
import Fhms2024Content from './pages/beef/data-preparation/fhms2024';
import Fhms2023Content from './pages/beef/data-preparation/fhms2023'; 
import Fhms2022Content from './pages/beef/data-preparation/fhms2022';
import Fhms2021Content from './pages/beef/data-preparation/fhms2021';
import Fhms2020Content from './pages/beef/data-preparation/fhms2020';
import Fhms2019Content from './pages/beef/data-preparation/fhms2019';

import Mvs2019Content from './pages/beef/data-preparation/mvs2019'; 
import Mvs2020Content from './pages/beef/data-preparation/mvs2020';
import Mvs2021Content from './pages/beef/data-preparation/mvs2021';

import Vahs2025Content from './pages/beef/data-preparation/vahs2025';
import Vahs2024Content from './pages/beef/data-preparation/vahs2024';
import Vahs2023Content from './pages/beef/data-preparation/vahs2023'; 
import Vahs2022Content from './pages/beef/data-preparation/vahs2022';
import Vahs2021Content from './pages/beef/data-preparation/vahs2021';
import Vahs2020Content from './pages/beef/data-preparation/vahs2020';
import Vahs2019Content from './pages/beef/data-preparation/vahs2019';

import Ssvs2025Content from './pages/beef/data-preparation/ssvs2025';

import Abhs from './pages/supplementary/data-preparation/abhs';
import Ssvs from './pages/supplementary/data-preparation/ssvs';
import Bvc from './pages/supplementary/data-preparation/bvc';
import Cvc from './pages/supplementary/data-preparation/cvc';
import Fhms from './pages/supplementary/data-preparation/fhms';
import Lah from './pages/supplementary/data-preparation/lah';
import Mvs from './pages/supplementary/data-preparation/mvs';
import Vahs from './pages/supplementary/data-preparation/vahs';

const AppLayout = styled.div`
  display: flex;
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: ${({ theme }) => theme.homeBg};
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 270px;
  margin-top: 60px;
  background: ${({ theme }) => theme.homeBg};
`;

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    // Load saved preference
    const saved = localStorage.getItem('darkMode') === 'true';
    setDarkMode(saved);
    
  }, []);

  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem('darkMode', newMode);
  };
  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
    <Router>
      <AppLayout>
        <Sidebar open={sidebarOpen} toggleSidebar={() => setSidebarOpen(!sidebarOpen)} darkMode={darkMode}/>
        
        <MainContent style={{ marginLeft: sidebarOpen ? '270px' : '60px' }}>
          <Header sidebarOpen={sidebarOpen} darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/RonsRants" element={<RonsRants />} />


            <Route path="/beef/survey-app" element={<SurveyApp />} />
            <Route path="/beef/templates" element={<Templates />} />
            
            <Route path="/beef/data-uploads" element={<DataUploads />} />
            <Route path="/beef/app-install" element={<AppInstall />} />

            
            <Route path="/beef/data-preparation/abhs2019" element={<Abhs2019Content />} />
        <Route path="/beef/data-preparation/abhs2020" element={<Abhs2020Content />} />
        <Route path="/beef/data-preparation/abhs2021" element={<Abhs2021Content />} />
        
        <Route path="/beef/data-preparation/cvc2024" element={<Cvc2024Content />} />
        <Route path="/beef/data-preparation/cvc2023" element={<Cvc2023Content />} />
        <Route path="/beef/data-preparation/cvc2022" element={<Cvc2022Content />} />
        <Route path="/beef/data-preparation/cvc2021" element={<Cvc2021Content />} />
        <Route path="/beef/data-preparation/cvc2020" element={<Cvc2020Content />} />
        <Route path="/beef/data-preparation/cvc2019" element={<Cvc2019Content />} />
        
        <Route path="/beef/data-preparation/fhms2025" element={<Fhms2025Content />} />
        <Route path="/beef/data-preparation/fhms2024" element={<Fhms2024Content />} />
        <Route path="/beef/data-preparation/fhms2023" element={<Fhms2023Content />} />
        <Route path="/beef/data-preparation/fhms2022" element={<Fhms2022Content />} />
        <Route path="/beef/data-preparation/fhms2021" element={<Fhms2021Content />} />
        <Route path="/beef/data-preparation/fhms2020" element={<Fhms2020Content />} />
        <Route path="/beef/data-preparation/fhms2019" element={<Fhms2019Content />} />

          <Route path="/beef/data-preparation/mvs2019" element={<Mvs2019Content />} />
          <Route path="/beef/data-preparation/mvs2020" element={<Mvs2020Content />} />
          <Route path="/beef/data-preparation/mvs2021" element={<Mvs2021Content />} />

        <Route path="/beef/data-preparation/vahs2025" element={<Vahs2025Content />} />    
        <Route path="/beef/data-preparation/vahs2024" element={<Vahs2024Content />} />
        <Route path="/beef/data-preparation/vahs2023" element={<Vahs2023Content />} />
        <Route path="/beef/data-preparation/vahs2022" element={<Vahs2022Content />} />
        <Route path="/beef/data-preparation/vahs2021" element={<Vahs2021Content />} />
        <Route path="/beef/data-preparation/vahs2020" element={<Vahs2020Content />} />
        <Route path="/beef/data-preparation/vahs2019" element={<Vahs2019Content />} />

        <Route path="/beef/data-preparation/ssvs2025" element={<Ssvs2025Content />} />

        <Route path= "/supplementary/data-preparation/abhs" element={<Abhs />} />
        <Route path= "/supplementary/data-preparation/ssvs" element={<Ssvs />} />
        <Route path= "/supplementary/data-preparation/bvc" element={<Bvc />} />
        <Route path= "/supplementary/data-preparation/vahs" element={<Vahs />} />
        <Route path= "/supplementary/data-preparation/cvc" element={<Cvc />} />
        <Route path= "/supplementary/data-preparation/mvs" element={<Mvs />} />
        <Route path= "/supplementary/data-preparation/fhms" element={<Fhms />} />
        <Route path= "/supplementary/data-preparation/lah" element={<Lah />} />
          </Routes>

          <Footer />
        </MainContent>
      </AppLayout>
    </Router>
    </ThemeProvider>
  );
}

export default App;
